document.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll('.range-single').forEach($wrapper => {
		const $input  = $wrapper.querySelector('.range-single__field');
		const $label  = $wrapper.querySelector('.range-single__value');
		const $track  = $wrapper.querySelector('.range-single__track');
		const $fill   = $wrapper.querySelector('.range-single__track__fill');
		const $thumb  = $wrapper.querySelector('.range-single__track__thumb');

		if (!$input || !$track) return;

		function update_ui() {
			const min     = +$input.min;
			const max     = +$input.max;
			const val     = +$input.value;
			const percent = (val - min) / (max - min);
			const px      = percent * $track.offsetWidth;

			$thumb.style.left  = `${px}px`;
			$fill.style.width  = `${px}px`;

			if ($label) $label.textContent = val;
		}

		// Drag via custom thumb (mirrors range-group.js pattern)
		let last_value = null;

		const get_x = (e) => e.type.startsWith('touch') ? e.touches[0].clientX : e.clientX;

		const on_move = (e) => {
			const rect    = $track.getBoundingClientRect();
			const x       = Math.max(0, Math.min(get_x(e) - rect.left, rect.width));
			const min     = +$input.min;
			const max     = +$input.max;
			const step    = +$input.step || 1;
			const raw     = min + (x / rect.width) * (max - min);
			const value   = Math.round(raw / step) * step;

			if (value === last_value) return;
			last_value    = value;
			$input.value  = value;
			update_ui();
		};

		const on_up = () => {
			if (last_value !== null) {
				$input.dispatchEvent(new Event('change', { bubbles: true }));
			}
			last_value = null;
			document.removeEventListener('mousemove', on_move);
			document.removeEventListener('mouseup',  on_up);
			document.removeEventListener('touchmove', on_move);
			document.removeEventListener('touchend',  on_up);
		};

		$thumb.addEventListener('mousedown', (e) => {
			e.preventDefault();
			last_value = null;
			document.addEventListener('mousemove', on_move);
			document.addEventListener('mouseup',   on_up);
		});

		$thumb.addEventListener('touchstart', (e) => {
			e.preventDefault();
			last_value = null;
			document.addEventListener('touchmove', on_move, { passive: false });
			document.addEventListener('touchend',  on_up);
		}, { passive: false });

		// Keep UI in sync when value changes programmatically (e.g. filter reset)
		$input.addEventListener('input',  () => update_ui());
		$input.addEventListener('change', () => update_ui());

		requestAnimationFrame(() => {
			setTimeout(() => update_ui(), 50);
		});
	});
});
